import gql from 'graphql-tag'

export const CHANGE_LANGUAGE = gql`
  mutation changeLanguage($id: Int!, $language: UserLanguage!) {
    changeLanguage(id: $id, language: $language)
  }
`
